import { useMemo } from 'react'
import { ExecutionBarConfig } from '../../../types/mf-execution.types'
import { getBottomPadding } from '../../../utils/sessionStorage'
import { EventNames } from '../../../types/misc.types'
import { trackEvent } from '../../../utils/appBridge'
import { ErrorExecutionBar } from './ErrorExecutionBar'
import { ButtonsList } from './ButtonsList'

export type ExecutionBarProps = {
  executionBarConfig: ExecutionBarConfig
  isScrim?: boolean
  isLoading?: boolean
  isError?: boolean
  onRetry: () => void
}

export const ExecutionBar = ({
  executionBarConfig,
  isScrim = true,
  isError = false,
  onRetry,
  isLoading = false
}: ExecutionBarProps) => {
  const scrimClassName = useMemo(() => {
    const staticClassName = 'flex w-full items-center gap-2 pt-7 px-5'
    const dynamicClassName = isScrim
      ? 'bg-gradient-to-t from-[#EDEDED] via-[rgba(237,237,237,0.6)] to-[rgba(237,237,237,0)]'
      : ''
    return `${staticClassName} ${dynamicClassName}`
  }, [isScrim])

  const buttons = useMemo(() => executionBarConfig.buttons, [executionBarConfig])
  const learnMore = useMemo(() => executionBarConfig.learnMore, [executionBarConfig])

  if (isError) {
    return <ErrorExecutionBar />
  }

  // if (isError) {
  //   return (
  //     <div
  //       style={{ paddingBottom: `${getBottomPadding() + 12 || 20}px` }}
  //       test-locator='MFL2_TXT_FAILED_TO_LOAD'
  //       className='bg-white w-full pt-3 px-5 flex flex-col gap-[10px] border-t border-solid border-[#F0F4F7]'
  //     >
  //       <div className='text-[#6A6E6E] text-[13px] font-[400] text-center'>Failed to load.</div>
  //       <SecondaryButton
  //         testLocator='MFL2_CTA_TRY_AGAIN'
  //         onClick={() => {
  //           trackEvent({
  //             eventName: EventNames.ButtonTap,
  //             payload: { ScreenName: 'MF_L2', buttonLabel: 'Retry', eventId: 'MFL2_CTA_TRY_AGAIN' }
  //           })
  //           onRetry()
  //         }}
  //         label={isLoading ? 'Loading...' : 'Retry'}
  //       />
  //     </div>
  //   )
  // }

  if (isLoading) {
    return null
  }

  if (learnMore) {
    return (
      <div
        style={{ paddingBottom: `${getBottomPadding() + 12 || 20}px` }}
        className='bg-white w-full pt-3 px-5 flex flex-col gap-[14px] border-t border-solid border-[#F0F4F7]'
      >
        <div className='text-[#6A6E6E] text-[13px] font-[400] text-center animate-fade-150'>
          {learnMore.text}{' '}
          <span
            test-locator='MFL2_CTA_LEARN_MORE'
            className='underline cursor-pointer'
            onClick={() => {
              trackEvent({
                eventName: EventNames.ButtonTap,
                payload: { ScreenName: 'MF_L2', buttonLabel: 'Learn more', eventId: 'MFL2_CTA_LEARN_MORE' }
              })
              learnMore.onClick()
            }}
          >
            Learn more
          </span>
        </div>
        <ButtonsList buttons={buttons} />
      </div>
    )
  }

  return (
    <div
      style={{ paddingBottom: `${getBottomPadding() + 12 || 20}px` }}
      className='bg-white w-full pt-5 px-5 flex flex-col gap-[14px] border-t border-solid border-[#F0F4F7]'
    >
      <div>
        <ButtonsList buttons={buttons} />
      </div>
    </div>
  )
}

